import { Component, Input } from '@angular/core'
import { PortfolioHoldingResponse } from 'src/app/models/portfolio-models/portfolio-holding-response.model'

@Component({
  selector: 'pcf-results',
  templateUrl: './pcf-results.component.html',
  styleUrls: ['./pcf-results.component.scss'],
})
export class PcfResultsComponent {
  @Input() pcfHoldings: PortfolioHoldingResponse
}
